import { useTranslation } from '@frontend/i18n';
import { AudienceTray } from '../audience-tray/audience-tray';

export const SegmentsViewHeader = () => {
  const { t } = useTranslation('bulk-messaging');
  return <AudienceTray.Header title={t('Create Audience')} />;
};
